import { useEffect, useState } from "react";
import { STAGES } from "@/site/content";
import WhitespaceGrid from "@/site/components/WhitespaceGrid";
import { track } from "@/site/analytics";

const DUR = 7000;

/** Five stages, one record. Auto-advances until hovered/focused; deep-linkable via #stage-<id>. */
export default function StageTour() {
  const fromHash = () => { const m = window.location.hash.match(/^#stage-(\w+)/); return m ? Math.max(0, STAGES.findIndex((s) => s.id === m[1])) : 0; };
  const [i, setI] = useState(fromHash);
  const [paused, setPaused] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (paused) return;
    const t = setTimeout(() => { setI((n) => (n + 1) % STAGES.length); setTick((x) => x + 1); }, DUR);
    return () => clearTimeout(t);
  }, [i, paused, tick]);

  const go = (n) => { setI(n); setTick((x) => x + 1); track("stage_tab", { stage: STAGES[n].id }); };
  const s = STAGES[i];

  return (
    <div className="tour" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)} data-testid="stage-tour">
      <div className="tour__list" role="tablist" aria-label="Deal stages">
        {STAGES.map((st, n) => (
          <button key={st.id} role="tab" id={`stage-${st.id}`} aria-selected={i === n} aria-controls={`panel-${st.id}`} className="tour__item" onClick={() => go(n)} data-testid={`stage-tab-${st.id}`}>
            <span className="tour__num">{st.n}</span>
            <span>
              <div className="tour__label">{st.label}</div>
              <div className="tour__short">{st.short}</div>
              {i === n && <div className={`tour__progress ${paused ? "" : "run"}`} key={tick} style={{ "--dur": `${DUR}ms` }}><i /></div>}
            </span>
          </button>
        ))}
      </div>
      <div className="tour__panel" role="tabpanel" id={`panel-${s.id}`} aria-labelledby={`stage-${s.id}`}>
        {s.id === "whitespace" ? (
          // Real, live component -- not a screenshot. demo={false} turns off
          // the hero-flip attention animation, which was built assuming this
          // sits right under the hero; here it would replay awkwardly every
          // time the tour auto-advances back around to stage 1.
          <WhitespaceGrid demo={false} />
        ) : (
          <div className="frame">
            <div className="frame__bar"><span>{s.label.toUpperCase()}</span><span>Same record · stage {s.n} of {STAGES.length}</span></div>
            <img src={s.image} alt={s.alt} width={s.w} height={s.h} loading="eager" data-testid="stage-image" />
          </div>
        )}
        <div className="tour__copy">
          {/* Body paragraph dropped -- title + the screenshot's own highlight now
              carry the "what is this" job, so the right-hand column is just the
              feature list, not a repeat of the same point in prose. */}
          <h3 className="h3" data-testid="stage-title">{s.title}</h3>
          <ul className="tour__bullets">{s.bullets.map((b) => <li key={b}>{b}</li>)}</ul>
        </div>
      </div>
    </div>
  );
}
